const ZonesList = [
  { value: 'India', name: 'India' },
  { value: 'Asia-Pacific', name: 'Asia-Pacific' },
  { value: 'Americas', name: 'Americas' },
  { value: 'Europe', name: 'Europe' },
  { value: 'Others', name: 'Others' }
];

export default ZonesList;
